import type { ActivityStatus } from "@/api/import/activity";

/** The fields every extract and load carries, whatever else differs between them. */
export type ActivityJob = {
  started_at?: string;
  ended_at?: string;
  error?: unknown;
  records_errored?: number;
};

// Extracts and loads don't have a status in the API, so we compute one similar to export activity.
export const getJobStatus = (job: ActivityJob): ActivityStatus => {
  // A job can fail before it starts, so an ended error is checked before a missing start.
  if (job.ended_at && job.error) {
    return "error";
  }
  if (!job.started_at) {
    return "queued";
  }
  if (!job.ended_at) {
    return "in_progress";
  }
  if ((job.records_errored ?? 0) > 0) {
    return "completed_with_errors";
  }

  return "success";
};
